   <app-common-step-progressbar 
   [steps]="steps" 
   [(currentActive)]="activeStep" 
   (stepChanged)="onStepChange($event)"
   [data]="data"
   (onNext)="onNext($event)"
   (lastButtonClicked)="lastClicked($event)"
   >
    <app-common-progress-step class="wrapper" [style]="{'height': flexHeight}">
      <app-common-import-tab  
      [data]="data">
      </app-common-import-tab>
    </app-common-progress-step>
    <app-common-progress-step class="wrapper" [style]="{'height': flexHeight}">
      <app-common-map-tab 
      [data]="data">
    </app-common-map-tab>
    </app-common-progress-step>
    <app-common-progress-step class="wrapper" [style]="{'height': flexHeight}">
      <app-common-preview-tab  [data]="data"></app-common-preview-tab>
  </app-common-progress-step>
  <app-common-progress-step  class="wrapper" [style]="{'height': flexHeight}">
    <app-common-error-tab  [data]="data"></app-common-error-tab>
  </app-common-progress-step>
  <app-common-progress-step [style]="{'height': flexHeight}">
    <app-common-summary-tab
    [data]="data"
    (newImport)="newImport($event)"
    ></app-common-summary-tab>
  </app-common-progress-step>

</app-common-step-progressbar>